import React from 'react'
import Fade from 'react-reveal/Fade'
import Select from '../../UI/Select/Select'
import Input from '../../UI/Input/Input'
import Map from '../../UI/Map/Map'
import ContentForm from '../../UI/ContentForm/ContentForm'
import Button from '../../UI/Button/Button'
import FetchData from '../../../shared/fetchData'
import {updateObject} from '../../../shared/utility'

        const ViewKiosk = (props) => {

    const [kioskTypes, setKioskTypes] = React.useState(props.kioskTypes)
    const [kioskType, setKioskType] = React.useState('')
    const [zones, setZones] = React.useState(props.zones)
    const [zone, setZone] = React.useState('')
    const [changeForm, setChangeForm] = React.useState(false)
    const [lat, setLat] = React.useState(35.7575)
    const [lon, setLon] = React.useState(51.4099)
    const [zoom, setZoom] = React.useState(14)
    const [kiosk, setKiosk] = React.useState({
        description: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                readOnly: true,
                placeholder: 'نام'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        address: {
            elementType: 'input',
            elementConfig: {
                type: 'textarea',
                readOnly: true,
                placeholder: 'آدرس'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        addressEn: {
            elementType: 'input',
            elementConfig: {
                type: 'textarea',
                readOnly: true,
                placeholder: 'آدرس انگلیسی'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        }
    })

    React.useEffect(() => {
        const ksk = kiosk
        ksk.description.value = props.kiosk.description
        ksk.address.value = props.kiosk.address
        ksk.addressEn.value = props.kiosk.addressEn
        setKiosk(ksk)
        setLat(props.kiosk.lat)
        setLon(props.kiosk.lon)
        if (props.kiosk.kioskType != null) {
            setKioskType({
                value: props.kiosk.kioskType.id,
                label: props.kiosk.kioskType.description
            })
            setKioskTypes([{
                    value: props.kiosk.kioskType.id,
                    label: props.kiosk.kioskType.description
                }])
        }
        if (props.kiosk.zone != null) {
            setZone({
                value: props.kiosk.zone.id,
                label: props.kiosk.zone.description
            })
            setZones([{
                    value: props.kiosk.zone.id,
                    label: props.kiosk.zone.description
                }])
        }
    }, [])

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(kiosk, {
            [controlName]: updateObject(kiosk[controlName], {
                value: event.target.value
            })
        });
        setKiosk(updatedControls)
    }
    const changeMapHandler = (event) => {
        let lat = event.target.getCenter().lat
        let lng = event.target.getCenter().lng
        let zoom = event.target.getZoom()
        let ksk = kiosk
        setLat(lat)
        setLon(lng)
        setZoom(zoom)
        var addressRaw = JSON.stringify({"lat": lat, "lon": lng, "version": "mtpx001"})
        var addressUrl = 'api/v1/geonames/getLatLonDesc'
        FetchData(addressRaw, addressUrl).then(response => response.json())
                .then(result => {
                    ksk.address.value = result.text
                    ksk.address.valid = true
                    setKiosk(ksk)
                    if (changeForm) {
                        setChangeForm(false)
                    } else {
                        setChangeForm(true)
                    }
                })
    }

    const changeLocation = (lat, lng) => {
        let ksk = kiosk
        var addressRaw = JSON.stringify({"lat": lat, "lon": lng, "version": "mtpx001"})
        var addressUrl = 'api/v1/geonames/getLatLonDesc'
        setLat(lat)
        setLon(lng)
        FetchData(addressRaw, addressUrl).then(response => response.json())
                .then(result => {
                    ksk.address.value = result.text
                    ksk.address.valid = true
                    setKiosk(ksk)
                    if (changeForm) {
                        setChangeForm(false)
                    } else {
                        setChangeForm(true)
                    }
                })
    }

    const changeKioskType = (selectedOption) => {
        setKioskType(selectedOption)
    }

    const changeZone = (selectedOption) => {
        setZone(selectedOption)
    }

    const formElementsArray = [];
    for (let key in kiosk) {
        formElementsArray.push({
            id: key,
            config: kiosk[key]
        })
    }

    let form = formElementsArray.map(formElement => {
        let col = '4 mt-2'
        if (formElement.config.elementConfig.type == 'textarea') {
            col = formElement.id == 'addressEn' ? "12 EN-input" : '12 mt-4'
        }
        if (formElement.id == 'address') {

            return (
                    <div className="ksk-form-map">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <Map
                                    cityId={'تهران'}
                                    lat={lat}
                                    lng={lon}
                                    zoom={zoom}
                                    latLngChangeHandler={changeMapHandler}
                                    changeLocation={changeLocation}
                                    />
                            </div>
                            <Input
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={formElement.config.value}
                                invalid={!formElement.config.valid}
                                shouldValidate={formElement.config.validation}
                                placeholder={formElement.config.placeholder}
                                errorMessage={formElement.config.errorMessage}
                                search={true}
                                col={col}
                                changed={(event) => inputChangedHandler(event, formElement.id)} />      
                        </div>
                    </div>
                    )
        } else {
            return (
                    <Input
                        key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        placeholder={formElement.config.placeholder}
                        errorMessage={formElement.config.errorMessage}
                        search={true}
                        col={col}
                        changed={(event) => inputChangedHandler(event, formElement.id)} />
                    )
        }
    })

    const shiftList = props.shifts != null && props.shifts.length != 0 ? props.shifts.map(s => {
        return (
                <div className="col-3 full-small">
                    <label className="container role-text">{s.startTime}-{s.endTime}
                        <input type="checkbox"
                               onChange={(event) => props.addShift(event, s.id)}
                               checked={props.kioskShifts !== null && props.kioskShifts.length != 0 && props.kioskShifts.includes(s.id)}
                               value="ENVELOPE" id="flexCheckDefault" />
                        <span className="checkmark"></span>
                    </label>
                </div>
                )
    })
            : ''
    return (
            <div>
                <Fade duration={200} left cascade>
                    <div>
                        <div className='row justify-content-center'>
                            <div className='ksk-cntnr'>
                                <ContentForm headetText='اطلاعات لاکر'>
                                    <div className='ksk-frm'>
                                        <div className='col-12'>
                                            <div className='row'>
                                                {form}
                                            </div>
                                        </div>
                                        <Select
                                            name="form-field-name"
                                            value={kioskType}
                                            placeholder="نوع لاکر"
                                            options={kioskTypes}
                                            onChange={changeKioskType}
                                            col="6 mt-2"
                                            />
                                        <Select
                                            name="form-field-name"
                                            value={zone}
                                            placeholder="zone"
                                            options={zones}
                                            onChange={changeZone}
                                            col="6 mt-2"
                                            />
                                        {shiftList}
                                    </div>
                                    <div className='row justify-content-center w-100 mt-3'>
                                        <div className='col-6 text-center'>
                                            <Button btnType="General" clicked=
                                                    {(event) => props.back(event, false)}
                                                    >برگشت</Button>
                                        </div>
                                    </div>
                                </ContentForm>
                            </div>
                        </div>
                    </div>
                </Fade>
            </div>
            )
}

export default ViewKiosk